module.exports = __webpack_public_path__ + "img/menu_up.fffbfb88.svg";